import { useEffect, useState } from "react";
import { useMountedRef } from "./use-mounted";

export function useKeyedMounted<T>(key: NonNullable<T>, delayMs: number): boolean {
  const [stateKey, setStateKey] = useState<null | T>(null);
  const isMountedRef = useMountedRef();

  useEffect(() => {
    if (delayMs === 0) {
      setStateKey(key);
    } else {
      const handle = () => {
        if (isMountedRef.current) {
          setStateKey(key);
        }
      };

      const id = setTimeout(handle, delayMs);

      return () => {
        clearTimeout(id);
      };
    }
  }, [key]);

  return key === stateKey;
}
